import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type CirclePersonProps = {
    className?: string;
};

const CirclePerson: FunctionComponent<CirclePersonProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'circle-person'}
            viewBox="0 0 250 250"
        >
            <path d="M125.5-.1C56.6-.1.5 56 .5 124.9s56.1 125 125 125 125-56.1 125-125-56.1-125-125-125zM50 212.9c7.5-5.5 23.2-15.4 43.9-21.4 37.6-10.8 74.3-4.1 109 19.7-20.6 18.5-47.7 29.7-77.4 29.7-28.8 0-55.2-10.6-75.5-28zm159.5-8.1c-46.8-32.7-90.1-30-118.5-21.8-23.4 6.8-40.3 18.1-47.8 23.7-20.9-21-33.8-49.9-33.8-81.7 0-64 52-116 116-116s116 52 116 116c.1 30.8-12.1 59-31.9 79.8z" />
            <path d="M123.4 49.5C92 49.5 66.5 75 66.5 106.4s25.5 56.9 56.9 56.9 56.9-25.5 56.9-56.9-25.5-56.9-56.9-56.9zm0 104.7c-26.4 0-47.9-21.5-47.9-47.9S97 58.5 123.4 58.5s47.9 21.5 47.9 47.9-21.5 47.8-47.9 47.8z" />
        </svg>
    );
};
export default CirclePerson;
